/* Franchitti's Fix: price-list cart + part-page installation upsell. No dependencies. */
(function () {
  if (window.__ffPC) return; window.__ffPC = true;
  /* ff_test bypass is LOCKED: it only works in the theme editor / unpublished-theme preview,
     or when ?ff_test=<key> matches the SHA-256 in data-test-hash (set in the snippets). */
  var tv = new URLSearchParams(location.search).get('ff_test');
  var S = window.Shopify || {};
  var inEditor = !!(S.designMode || (S.theme && S.theme.role && S.theme.role !== 'main'));
  function hex(buf) { return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  var el = document.querySelector('[data-test-hash]'), want = el ? el.getAttribute('data-test-hash') : '';
  var testP = !tv ? Promise.resolve(false)
    : (tv === '1' && inEditor) ? Promise.resolve(true)
    : (want && window.crypto && crypto.subtle) ? crypto.subtle.digest('SHA-256', new TextEncoder().encode(tv)).then(function (b) { return hex(b) === want; }).catch(function () { return false; })
    : Promise.resolve(false);
  testP.then(run);
  function run(test) {
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var mapCache = null;
  function getMap(url) { return mapCache || (mapCache = fetch(url).then(function (r) { return r.json(); })); }
  function cartUI() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function addItems(items, render) {
    var body = { items: items }, ui = render && cartUI();
    if (ui && ui.getSectionsToRender) {
      body.sections = ui.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* Same refresh the theme's own add-to-cart uses: renderContents() redraws the drawer + cart count and opens it. */
  function showCart(res) {
    var ui = cartUI();
    if (ui && ui.renderContents && res && res.sections) {
      ui.classList.contains('is-empty') && ui.classList.remove('is-empty');
      ui.renderContents(res);
    } else if (!ui) { window.location.href = '/cart'; return; }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ff-install-upsell', cartData: res });
  }
  function cart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  /* installation-iphone-14-pro-max <-> 'iPhone 14 Pro Max' (labels used by the install map's m field). */
  var FF_SPECIAL = { 'se-2020': 'SE (2020)', 'se-2022': 'SE (2022)', 'xs-max': 'XS Max', 'xs': 'XS', 'xr': 'XR', 'x': 'X', 'air': 'Air' };
  function ffModelLabel(handle) {
    var s = String(handle || '').replace(/^installation-iphone-/, '');
    return 'iPhone ' + (FF_SPECIAL[s] || s.replace('-pro-max', ' Pro Max').replace('-pro', ' Pro').replace('-plus', ' Plus').replace('-mini', ' mini'));
  }
  function ffModelHandle(label) {
    var s = String(label || '').replace(/^iPhone /, ''), r = null;
    Object.keys(FF_SPECIAL).forEach(function (k) { if (FF_SPECIAL[k] === s) r = k; });
    return 'iphone-' + (r || s.toLowerCase().replace(/ /g, '-'));
  }
  function uid() { return 'FF-' + Date.now().toString(36).toUpperCase().slice(-6); }

  /* ---------- price-list pages ---------- */
  var root = document.getElementById('ff-pc-root');
  if (root) {
    var live = root.dataset.live === 'true' || test;
    var drawer = root.querySelector('.ff-pc-drawer');
    function openDrawer() {
      cart().then(function (c) {
        var ul = root.querySelector('.ff-pc-lines'); ul.innerHTML = '';
        c.items.slice(0, 6).forEach(function (it) {
          var li = document.createElement('li'); li.className = 'ff-pc-line';
          li.innerHTML = '<span></span><strong>' + money(it.final_line_price) + '</strong>';
          li.firstChild.textContent = it.product_title + (it.variant_title ? ' – ' + it.variant_title : '');
          ul.appendChild(li);
        });
        root.querySelector('.ff-pc-total__val').textContent = money(c.total_price);
        root.hidden = false; drawer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        root.querySelector('.ff-pc-close').focus();
      });
    }
    function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); setTimeout(function () { root.hidden = true; }, 250); }
    root.querySelector('.ff-pc-close').addEventListener('click', closeDrawer);
    root.querySelector('.ff-pc-continue').addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

    getMap(root.dataset.map).then(function (map) {
      var rowsMap = map.pages[root.dataset.page]; if (!rowsMap) return;
      var tpl = document.getElementById('ff-pc-toggle-tpl');
      function addBadge() {
        if (!live || document.querySelector('.ff-pc-badge')) return;
        var first = document.querySelector('tr.ff-pc-card'); if (!first) return;
        var host = first.closest('.rte, .page, main') || first.closest('table').parentNode;
        var b = document.createElement('p'); b.className = 'ff-pc-badge';
        b.innerHTML = '<span class="ff-pc-badge__dot" aria-hidden="true"></span>Live Prices \u00b7 Updated Automatically';
        host.insertBefore(b, host.firstChild);
      }
      document.querySelectorAll('.rte table tr, .page table tr, main table tr').forEach(function (tr) {
        var tds = tr.querySelectorAll('td'); if (tds.length < 2) return;
        var s = tds[0].querySelector('strong'); if (!s) return;
        var entries = (rowsMap[s.textContent.trim()] || []).filter(function (e) { return e.p.length; });
        if (!entries.length) {
          var lc = tds[tds.length - 1];
          if (!live && /\$\s?\d/.test(lc.textContent) && !lc.querySelector('.ff-pc-book')) {
            tr.classList.add('ff-pc-card'); var bx = document.createElement('div'); bx.className = 'ff-pc-actions';
            bx.innerHTML = '<a class="ff-pc-book" href="/pages/book-appointment" target="_blank" rel="noopener">Book Online</a>'; lc.appendChild(bx);
          }
          return;
        }
        var e = entries[0], cell = tds[tds.length - 1];
        tr.classList.add('ff-pc-card');
        var box = document.createElement('div'); box.className = 'ff-pc-actions';
        if (!live) {
          var old = cell.querySelector('.ff-pc-actions'); if (old) old.remove();
          box.innerHTML = '<a class="ff-pc-book" href="/pages/book-appointment" target="_blank" rel="noopener">Book Online</a>';
          cell.appendChild(box); return;
        }
        var bd = document.createElement('div'); bd.className = 'ff-pc-breakdown';
        bd.innerHTML = '<span class="ff-pc-bd__part"><span>Part</span> <b class="ff-pc-bd__pv">…</b></span><span class="ff-pc-bd__op" aria-hidden="true">+</span><span class="ff-pc-bd__lab"><span>Installation</span> <b>' + money(Math.round(e.l * 100)) + '</b></span><span class="ff-pc-bd__op" aria-hidden="true">=</span><span class="ff-pc-bd__total"><span>Total</span> <b class="ff-pc-bd__tv">…</b></span>';
        box.appendChild(bd);
        var partC = null, labC = Math.round(e.l * 100);
        function paint() {
          var on = input.checked;
          bd.classList.toggle('is-part-only', !on);
          if (partC === null) return;
          bd.querySelector('.ff-pc-bd__pv').textContent = money(partC);
          bd.querySelector('.ff-pc-bd__tv').textContent = money(partC + (on ? labC : 0));
        }
        Promise.all(e.p.map(function (v) { return fetch('/variants/' + v + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }); }))
          .then(function (vs) { partC = vs.reduce(function (a, v) { return a + v.price; }, 0); paint(); })
          .catch(function () { bd.classList.add('is-no-part'); });
        var tg = tpl.content.cloneNode(true); box.appendChild(tg);
        var input = box.querySelector('input');
        input.addEventListener('change', paint);
        var lab = box.querySelector('.ff-pc-toggle > span:last-child');
        lab.textContent = 'Include installation (+' + money(Math.round(e.l * 100)) + ')';
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ff-pc-btn ff-pc-btn--gold ff-pc-add';
        btn.textContent = 'Add to cart'; box.appendChild(btn); cell.appendChild(box);
        btn.addEventListener('click', function () {
          if (btn.disabled) return; btn.disabled = true; btn.classList.add('is-busy');
          var g = uid(), items = e.p.map(function (v) { return { id: v, quantity: 1, properties: { _ff_group: g } }; }).reverse();
          if (input.checked) items.unshift({ id: e.i, quantity: 1, properties: { _ff_group: g, 'Installed at': "Franchitti's Fix" } });
          addItems(items).then(function () {
            btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.textContent = 'Added ✓';
            setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = 'Add to cart'; }, 2200);
            openDrawer();
          }).catch(function (err) {
            btn.disabled = false; btn.classList.remove('is-busy');
            btn.textContent = (err && err.status === 422) ? 'Part out of stock – call (720) 413-8150' : 'Try again';
          });
        });
      });
      addBadge();
    });
  }

  /* ---------- part product pages (GMC landing): opt-in only ---------- */
  function initUpsell() {
    document.querySelectorAll('.ff-iu').forEach(function (box) {
      if (box.dataset.ffInit || !(box.dataset.live === 'true' || test)) return;
      box.dataset.ffInit = '1';
      var url = box.dataset.map;
      getMap(url).catch(function () { mapCache = null; return fetch(url, { cache: 'no-store' }).then(function (r) { return r.json(); }); }).then(function (map) {
        var form = document.querySelector('form[id^="product-form-"]:not(.installment)') || document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]:not(.installment)');
        function current() { var i = form && form.querySelector('[name="id"]'); return i && i.value ? i.value : box.dataset.variant; }
        function render() {
          var opts = map.parts[String(current())]; var btn = box.querySelector('.ff-iu__btn');
          if (!opts) { box.hidden = true; return; }
          /* Multi-model parts: options carry m (device). Show "Which phone?" and add that model's labor; default = first option. */
          var models = []; opts.forEach(function (x) { if (x.m && models.indexOf(x.m) < 0) models.push(x.m); });
          var pick = box.querySelector('.ff-iu__pick');
          if (models.length > 1) {
            if (!pick) {
              pick = document.createElement('label'); pick.className = 'ff-iu__pick';
              pick.style.cssText = 'display:flex;align-items:center;gap:8px;margin:0 0 10px;flex-wrap:wrap;color:#2c3a32;font-size:14px;font-weight:700';
              pick.innerHTML = '<span>Which phone?</span><select class="ff-iu__model" style="font:inherit;font-weight:600;font-size:15px;padding:8px 12px;min-height:44px;border:2px solid #bfa48f;border-radius:8px;background:#fff;color:#1a211e;cursor:pointer"></select>';
              box.insertBefore(pick, btn);
              pick.querySelector('select').addEventListener('change', render);
            }
            var sel = pick.querySelector('select'), keep = sel.value;
            if (sel.dataset.v !== models.join('|')) {
              sel.innerHTML = models.map(function (m) { return '<option>' + m.replace(/</g, '') + '</option>'; }).join('');
              sel.dataset.v = models.join('|'); if (models.indexOf(keep) > -1) sel.value = keep;
            }
            pick.hidden = false;
          } else if (pick) { pick.hidden = true; }
          var chosen = models.length > 1 ? pick.querySelector('select').value : null;
          var o = opts[0]; if (chosen) { for (var j = 0; j < opts.length; j++) { if (opts[j].m === chosen) { o = opts[j]; break; } } }
          var pv = String(current()); btn.textContent = 'Add part + installation +' + money(Math.round(o.l * 100));
          btn.disabled = false;
          btn.onclick = function () {
            btn.disabled = true;
            /* One call: part + labor share _ff_link; labor names its part in _ff_part (ff-cart-link.js removes orphans). */
            var k = uid();
            /* Battery labor is free when this model's screen labor (SKU A01) is already in the cart: add the part with a note instead. */
            var free = /^Battery/.test(o.n) ? fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              return (c.items || []).some(function (it) { return /^installation-/.test(it.handle || '') && /^A01/.test(it.sku || '') && ffModelLabel(it.handle) === o.m; });
            }).catch(function () { return false; }) : Promise.resolve(false);
            free.then(function (isFree) {
            if (isFree) {
              var note = "Installed with your screen, no extra labor";
              return addItems([{ id: Number(pv), quantity: 1, properties: { _ff_link: k, _ff_note: note, Installation: note, _ff_bat_labor: String(o.i), _ff_bat_model: ffModelHandle(o.m) } }], true)
                .then(function (res) { btn.textContent = 'Part added – installed free with your screen ✓'; showCart(res); if (window.ffCartLinkCheck) window.ffCartLinkCheck(); });
            }
            /* Labor first in the array: Shopify lists the last-added line on top, so this shows the part above its labor (tested on this store). */
            return addItems([{ id: o.i, quantity: 1, properties: { _ff_link: k, _ff_part: pv, 'Installed at': "Franchitti's Fix" } },
                      { id: Number(pv), quantity: 1, properties: { _ff_link: k } }], true)
              .then(function (res) { btn.textContent = 'Part + installation added ✓'; showCart(res); if (window.ffCartLinkCheck) window.ffCartLinkCheck(); });
            }).catch(function (err) { btn.disabled = false; btn.textContent = (err && err.status === 422) ? 'Part out of stock – call (720) 413-8150' : 'Try again'; });
          };
          box.hidden = false;
        }
        render();
        if (form) form.addEventListener('change', function () { setTimeout(render, 0); });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 0); });
      }).catch(function () { delete box.dataset.ffInit; });
    });
  }
  initUpsell();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initUpsell);
  window.addEventListener('load', initUpsell);
  document.addEventListener('shopify:section:load', initUpsell);
  }
})();
